import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";

export const requestDeleteReseller = async (
  resellerId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesResellers.Reseller, resellerId)
  );
};
